// extracted by mini-css-extract-plugin
export default {"copyText":"src-components-CopyText-css-module__copyText--pcSCs","icon":"src-components-CopyText-css-module__icon--tQhqT","cursor":"src-components-CopyText-css-module__cursor--f4lES"};